<template>
  <div><RegisterForm :id="2" /></div>
</template>

<script>
import RegisterForm from "./RegisterForm.vue";
export default {
  name: "CompanyForm",
  components: {
    RegisterForm,
  },
};
</script>

<style></style>
